import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import {Achievement} from "../../../types/Achievement";
import useGetAchievements from "../../../hooks/api/useGetAchievements";

// Types ----

type AchievementsPanelProps = {
  onSelect: (achievement: Achievement) => void
  selectedItems: SelectedItemsData
  isMaxSelected?: boolean
}

// Component ----

function AchievementsPanel({ onSelect, selectedItems, isMaxSelected }: AchievementsPanelProps) {
  const {data: achievements, isLoading} = useGetAchievements({
    perPage: 1000,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!achievements?.data?.length ? achievements?.data.map(achievement => {
                const selected = isSelected(achievement, ENTITY_TYPES.ACHIEVEMENT, selectedItems);

                return (
                  <Card
                    key={achievement.id}
                    onClick={() => onSelect(achievement)}
                    heading={achievement.name}
                    footer={achievement.description}
                    imageUrl={achievement.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {AchievementsPanel};